
import * as React from "react"
import { cn } from "@/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  variant?: 'default' | 'purple'
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant = 'default', ...props }, ref) => {
    const variantStyles = {
      default: {
        border: "border-accent/20",
        focusBorder: "focus-visible:border-accent/40",
        hoverBorder: "hover:border-accent/30",
        bg: "bg-white/30 dark:bg-white/10"
      },
      purple: {
        border: "border-purple-200 dark:border-purple-800",
        focusBorder: "focus-visible:border-purple-400 dark:focus-visible:border-purple-600",
        hoverBorder: "hover:border-purple-300 dark:hover:border-purple-700",
        bg: "bg-purple-50/30 dark:bg-purple-900/20"
      }
    };

    const styles = variantStyles[variant];

    return (
      <div className="relative w-full">
        <textarea
          className={cn(
            "flex min-h-[80px] w-full rounded-md px-3 py-2 text-sm ring-offset-background",
            "backdrop-blur-sm",
            styles.bg,
            styles.border,
            "focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0",
            "focus:outline-none focus:ring-0 focus:ring-offset-0",
            styles.focusBorder,
            "focus:border-accent/40",
            "transition-all duration-300 shadow-sm hover:shadow-md",
            styles.hoverBorder,
            "placeholder:text-gray-400 hover:placeholder:text-gray-200",
            "disabled:cursor-not-allowed disabled:opacity-50",
            className
          )}
          ref={ref}
          {...props}
        />
      </div>
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
